import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

interface SupportStaff {
  id: number;
  name: string;
}

interface Filters {
  branch_id: number;
  sex?: string;
  stage?: string;
  has_pending_tasks?: "0" | "1";
  max_users?: number;
}

interface TaskDetails {
  name_task: string;
  date_task: string;
  support: number;
  labels_id: number[];
  execution_day?: string;
}

interface MassLeadTasksRequest {
  filters: Filters;
  task_details: TaskDetails;
}

export const catchmentApi = api
  .enhanceEndpoints({
    addTagTypes: ["SupportStaff"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getSupportStaff: builder.query<SupportStaff[], { branch_id: string }>({
        query: ({ branch_id }) => ({
          url: `get-support-staff?branch_id=${branch_id}`,
          method: RequestMethod.GET,
        }),
        providesTags: ["SupportStaff"],
      }),

      massLeadTasks: builder.mutation<any, MassLeadTasksRequest>({
        query: (body) => ({
          url: `mass-lead-tasks`,
          method: RequestMethod.POST,
          body,
        }),
      }),
    }),
  });

export const { useGetSupportStaffQuery, useMassLeadTasksMutation } = catchmentApi;
